import { inject, Injectable } from '@angular/core';
import { BaseService } from '@shared/core';
import { IParkomatsModel } from '@pkp-g/core';
import { Observable } from 'rxjs';
import { IParkomatsFilterModel, IParkomatsResponseModel } from '@pkp-g/core';

@Injectable({
  providedIn: 'root',
})
export class ParkomatsApiService {
  private http = inject(BaseService);
  apiUrl = 'v1/parkomats';

  getAllParkomats(filter?: IParkomatsFilterModel): Observable<IParkomatsResponseModel> {
    return this.http.get<IParkomatsResponseModel>(`${this.apiUrl}`, filter);
  }

  getParkomatById(id?: string): Observable<IParkomatsModel> {
    return this.http.get<IParkomatsModel>(`${this.apiUrl}/${id}`);
  }

  createParkomat(payload: IParkomatsModel): Observable<IParkomatsModel> {
    return this.http.post<IParkomatsModel>(`${this.apiUrl}`, payload);
  }

  editParkomat(id: string, payload: IParkomatsModel): Observable<IParkomatsModel> {
    return this.http.put<IParkomatsModel>(`${this.apiUrl}/${id}`, payload);
  }

  deleteParkomatById(id?: string): Observable<unknown> {
    return this.http.delete<unknown>(`${this.apiUrl}/${id}`);
  }
}
